export default __webpack_public_path__ + "0aa7e183c51f96bb4e8e157c864ceb3f.png";